import React, { Component } from "react"
import PropTypes from 'prop-types'
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"
import {
  changeLayout,
  changeSidebarTheme,
  changeSidebarThemeImage,
  changeSidebarType,
  toggleRightSidebar,
  changeTopbarTheme,
  changeLayoutWidth,
  getUserDetail
} from "../../store/actions"

// Layout Related Components
import Header from "./Header"
import Sidebar from "./Sidebar"
import Footer from "./Footer"
import { leftSidebarTypes } from "../../constants/layout"
import {
  applyStoredVerticalMenuState,
  persistVerticalMenuToggle,
} from "../../helpers/verticalMenuState"

let agentExtRequestedFor = null

const sameAgent = (detail, userId) => {
  if (!detail || userId == null || userId === "") return false
  return String(detail.agentId ?? detail.id) === String(userId)
}

class Layout extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isMobile: /iPhone|iPad|iPod|Android/i.test(navigator.userAgent),
      width: 0,
      height: 0,
      isResponsive: window.innerWidth < 768,
    }
    this.toggleMenuCallback = this.toggleMenuCallback.bind(this)
    this.toggleRightSidebar = this.toggleRightSidebar.bind(this)
  }

  toggleRightSidebar() {
    this.props.toggleRightSidebar()
  }

  capitalizeFirstLetter = string => {
    return string.charAt(1).toUpperCase() + string.slice(2)
  }

  componentDidMount() {
    const { getUserDetail } = this.props
    const userId = localStorage.getItem("userId")
    const passwordChangePending = localStorage.getItem("isChangePasswordRequired") === "true"
    if (!passwordChangePending && !sameAgent(this.props.userdetail, userId) && agentExtRequestedFor !== String(userId)) {
      agentExtRequestedFor = String(userId)
      getUserDetail(userId)
    }
    if (this.props.isPreloader === true) {
      document.getElementById("preloader").style.display = "block"
      document.getElementById("status").style.display = "block"

      setTimeout(function () {
        document.getElementById("preloader").style.display = "none"
        document.getElementById("status").style.display = "none"
      }, 2500)
    } else {
      document.getElementById("preloader").style.display = "none"
      document.getElementById("status").style.display = "none"
    }


     window.addEventListener("resize", () => {
        this.setState({ isResponsive: window.innerWidth < 768 });
        this.reapplyStoredVerticalMenuState();
        });

    // Scroll Top to 0
    window.scrollTo(0, 0)
    // let currentage = this.capitalizeFirstLetter(this.props.location.pathname)

    // document.title =
    //   currentage + " | Skote - React Admin & Dashboard Template"
    document.title = "Agent portal - Realty Space"
    if (this.props.leftSideBarTheme) {
      this.props.changeSidebarTheme(this.props.leftSideBarTheme)
    }

    if (this.props.leftSideBarThemeImage) {
      this.props.changeSidebarThemeImage(this.props.leftSideBarThemeImage)
    }

    if (this.props.layoutWidth) {
      this.props.changeLayoutWidth(this.props.layoutWidth)
    }

    if (this.props.leftSideBarType) {
      this.props.changeSidebarType(this.props.leftSideBarType)
    }
    if (this.props.topbarTheme) {
      this.props.changeTopbarTheme(this.props.topbarTheme)
    }

    if (this.props.showRightSidebar) {
      this.toggleRightSidebar()
    }

    // Reapply after saga runs (condensed type resets body classes on each route).
    setTimeout(() => this.reapplyStoredVerticalMenuState(), 0)
  }

  reapplyStoredVerticalMenuState = () => {
    if (this.props.leftSideBarType !== leftSidebarTypes.DEFAULT) return
    applyStoredVerticalMenuState()
  }

  toggleMenuCallback = () => {
    const body = document.body
    if (window.innerWidth <= 998) {
      body.classList.toggle("sidebar-enable")
    } else {
      body.classList.toggle("vertical-collpsed")
      body.classList.toggle("sidebar-enable")
    }
    persistVerticalMenuToggle()
  }

  render() {
    const { userdetail } = this.props;
    const {isResponsive } = this.state;
    return (
      <React.Fragment>
        <div id="preloader">
          <div id="status">
            <div className="spinner-chase">
              <div className="chase-dot"></div>
              <div className="chase-dot"></div>
              <div className="chase-dot"></div>
              <div className="chase-dot"></div>
              <div className="chase-dot"></div>
              <div className="chase-dot"></div>
            </div>
          </div>
        </div>

        <div id="layout-wrapper">
          <Header
            toggleMenuCallback={this.toggleMenuCallback}
            toggleRightSidebar={this.toggleRightSidebar}
            userdetail={userdetail}
            disableMenuToggle={window.innerWidth < 1601}
          />
          <Sidebar
            theme={this.props.leftSideBarTheme}
            type={this.props.leftSideBarType}
            isMobile={this.state.isMobile}
          />
          <div className="main-content">
            {React.Children.map(this.props.children, child =>
              React.cloneElement(child, { userdetail, isResponsive })
            )}
          </div>
          <Footer />
        </div>
      </React.Fragment>
    )
  }
}

Layout.propTypes = {
  changeLayoutWidth: PropTypes.func,
  changeSidebarTheme: PropTypes.func,
  changeSidebarThemeImage: PropTypes.func,
  changeSidebarType: PropTypes.func,
  changeTopbarTheme: PropTypes.func,
  children: PropTypes.any,
  isPreloader: PropTypes.bool,
  layoutWidth: PropTypes.any,
  leftSideBarTheme: PropTypes.any,
  leftSideBarThemeImage: PropTypes.any,
  leftSideBarType: PropTypes.any,
  location: PropTypes.object,
  showRightSidebar: PropTypes.any,
  toggleRightSidebar: PropTypes.any,
  topbarTheme: PropTypes.any,
  getUserDetail: PropTypes.func,
  userdetail: PropTypes.object,
}

const mapStateToProps = state => {
  return {
    ...state.Layout,
    userdetail: state.Login.userdetail,
  }
}

export default connect(mapStateToProps, {
  changeLayout,
  changeSidebarTheme,
  changeSidebarThemeImage,
  changeSidebarType,
  //toggleRightSidebar,
  changeTopbarTheme,
  changeLayoutWidth,
  getUserDetail,
})(withRouter(Layout))
